
const scrollContainers = document.querySelectorAll('[data-scrollable]');

if (scrollContainers.length > 0) {
    scrollContainers.forEach(scrollContent => {
        let isDown = false;
        let startX;
        let scrollLeft;

        scrollContent.classList.add('no-drag');
        scrollContent.setAttribute('no-drag', 'on');
        scrollContent.setAttribute('draggable', 'false');
        scrollContent.addEventListener('dragstart', function( event ) {
            event.preventDefault();
        }, false);

        scrollContent.addEventListener('mousedown', (e) => {
            isDown = true;
            scrollContent.classList.add('active');
            startX = e.pageX - scrollContent.offsetLeft;
            scrollLeft = scrollContent.scrollLeft;
        });

        scrollContent.addEventListener('mouseleave', () => {
            isDown = false;
            scrollContent.classList.remove('active');
        });

        scrollContent.addEventListener('mouseup', () => {
            isDown = false;
            scrollContent.classList.remove('active');
        });

        scrollContent.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollContent.offsetLeft;
            const walk = (x - startX) * 2; //
            scrollContent.scrollLeft = scrollLeft - walk;
        });
    });
}